import { Nullable } from "@/api/ApiClient";

export type RecibeFormData = Nullable<{
    id: string | undefined,
    numero: string,
    total: number,
    abono: number,
    motivo: string,
    nombre: string,
    created: string,
    forma_pago: string,
    exchange_rate: number,
    reference: string,
    digitosTarjeta: string,
    numAprobacion: string,
    anulado: boolean,
    clientId: string,
    client: any,
    currencyId: string,
    currency: any,
    creditOperatorId: string,
    creditOperator: any,
    bankAccountId: string,
    bankAccount: any,
    invoices: any[],
    invoicePayments: any[],
    settlements: any[],
    settlementPayments: any[],
    interestEntries: any[],
    user: string,
}>;

export const RecibeRelatedAttributes: Array<keyof RecibeFormData> = ["client", "currency", "creditOperator", "bankAccount", "invoices", "settlements", "interestEntries", "invoicePayments", "settlementPayments"];